import { defineStore, acceptHMRUpdate } from "pinia";
import { ref } from "vue";

export const useErrorStore = defineStore("error", () => {
  const message = ref<string | undefined>(undefined);
  const allowHtml = ref(true);
  const defaultErrorMessage = ref(
    "Server is taking too long to respond. Please wait a few minutes and try again.",
  );

  return {
    message,
    allowHtml,
    defaultErrorMessage,
    showError: (msg: string, allowHtml_?: boolean) => {
      message.value = msg;
      allowHtml.value = allowHtml_ ?? true;
    },
    dismissError: () => {
      message.value = undefined;
      allowHtml.value = true;
    },
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useErrorStore, import.meta.hot));
}
